import React from "react";

//MUI
import SvgIcon from '@mui/material/SvgIcon';

//Types
import { SvgIconProps } from "@mui/material";

function ToolSettingsIcon(props: SvgIconProps) {
  return <SvgIcon {...props}>
  <svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
    width="100px" height="100px" fill="currentcolor" viewBox="0 0 100 100" enableBackground="new 0 0 100 100" xmlSpace="preserve">
  <polygon points="70,22 70,14 62,14 62,38.001 70,38.001 70,30 86,30 86,22"/>
  <rect x="14" y="22" width="40" height="8"/>
  <rect x="46" y="46" width="40" height="8"/>
  <rect x="14" y="70" width="24" height="8"/>
  <polygon points="30,46 14,46 14,54 30,54 30,62 38,62 38,38 30,38"/>
  <polygon points="54,62 46,62 46,86 54,86 54,78 86,78 86,70 54,70"/>
  </svg>

  </SvgIcon>
}

export default ToolSettingsIcon;
